import { render, staticRenderFns } from "./AssetChartsView.vue?vue&type=template&id=0bff8353&scoped=true&"
import script from "./AssetChartsView.vue?vue&type=script&lang=js&"
export * from "./AssetChartsView.vue?vue&type=script&lang=js&"
import style0 from "./AssetChartsView.vue?vue&type=style&index=0&id=0bff8353&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff8353",
  null
  
)

/* custom blocks */
import block0 from "./AssetChartsView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports